module.exports = __webpack_public_path__ + "img/marketing_sharing.9716c62d.svg";